import { render, staticRenderFns } from "./errText.vue?vue&type=template&id=07204dde&scoped=true&"
import script from "./errText.vue?vue&type=script&lang=js&"
export * from "./errText.vue?vue&type=script&lang=js&"
import style0 from "./errText.vue?vue&type=style&index=0&id=07204dde&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07204dde",
  null
  
)

export default component.exports